import React from 'react';
import { FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const reviews = [
  {
    id: 1,
    name: "Marcus T.",
    city: "NYC",
    text: "The Titan U-Lock survived an attempted angle grinder attack in Brooklyn. Worth every single penny. The orange casing makes it highly visible too.",
    product: "Titan U-Lock"
  },
  {
    id: 2,
    name: "Sarah J.",
    city: "Seattle",
    text: "Riding in the rain is standard here. The AeroCommute bag keeps my laptop bone dry, and the LumenBlast light cuts through the gloom.",
    product: "Commute Kit"
  },
  {
    id: 3,
    name: "David K.",
    city: "Chicago",
    text: "Finally, gear that doesn't look like it belongs in the Tour de France. Practical, tough, and looks good locked up outside the office.",
    product: "Messenger DryLite"
  }
];

const Reviews = () => {
  return (
    <section className="py-24 bg-asphalt-dark">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <div>
            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4">
              Word on the <span className="text-signal">Street</span>
            </h2>
            <p className="text-gray-400 max-w-xl">Don't take our word for it. Hear from riders navigating the same concrete grid as you.</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-3xl font-black text-white">4.9</span>
            <div className="flex text-signal text-xl">
              {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current" />)}
            </div>
            <span className="text-gray-500 text-sm ml-2">(2,450+ Reviews)</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div key={review.id} className="bg-asphalt p-8 rounded-sm border border-white/5 relative">
              <div className="absolute top-0 right-0 p-4 opacity-10">
                <span className="text-6xl font-serif text-white">"</span>
              </div>
              <div className="flex text-signal mb-4">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current text-sm" />)}
              </div>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed relative z-10">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between border-t border-white/10 pt-4 mt-auto">
                <div>
                  <h4 className="font-bold text-white">{review.name}</h4>
                  <p className="text-sm text-gray-500">{review.city}</p>
                </div>
                <span className="text-xs font-bold text-signal uppercase tracking-wider bg-signal/10 px-2 py-1 rounded-sm">
                  {review.product}
                </span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Reviews;